// import React, { useEffect, useState } from 'react';
// import { Line } from 'react-chartjs-2';
// import { Chart, registerables } from 'chart.js';

// Chart.register(...registerables);

// function LineChart({ data, graph_det }) {
//   const [chartData, setChartData] = useState({});
//   const [minVal, setMinVal] = useState(Number.POSITIVE_INFINITY);
//   const [maxVal, setMaxVal] = useState(Number.NEGATIVE_INFINITY);
  

  
// useEffect(() => {
//   if (data) {
//     let min = Number.POSITIVE_INFINITY;
//     let max = Number.NEGATIVE_INFINITY;
//     const allLabels = new Set();
//     const datasets = [];
//     const isMergedGraph = graph_det.merged_graphs;
//     const isGraphMerged = Array.isArray(isMergedGraph) && isMergedGraph.length > 0;

//     const mergedGraphName = isGraphMerged ? graph_det.merged_graphs[0].name : null;
//     const mergedGraphColor = isGraphMerged ? graph_det.merged_graphs[0].colors || ["#00BFFF", "#00BFFF", "#00BFFF"] : null;
//     const safeColors = graph_det?.colors?.length >= 3
//         ? graph_det.colors
//         : ["#00BFFF", "#00BFFF", "#00BFFF"]; // fallback for non-merged graph
    
    



//     data.forEach((dataset, i) => {
//       // Ensure dataset is sorted by datetime
//       const sortedData = [...dataset].sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

//       const dataPoints = sortedData.map(d => {
//         const value = parseFloat(d.value);
//         min = Math.min(min, value); // Update min value
//         max = Math.max(max, value); // Update max value

//         const labelDate = d.datetime.split(' ')[0];
//         allLabels.add(labelDate);

//         return { x: labelDate, y: value };
//       });
//       const datasetLabel = i === 0 
//       ? `${graph_det.name}` // First dataset gets the specific graph name
//       : mergedGraphName;    // Second dataset gets the merged graph name
    
 

//       datasets.push({
//         label: datasetLabel,
//         data: dataPoints,
//         backgroundColor: 'rgba(255, 255, 255, 0.1)',
//         fill: true,
//         pointBackgroundColor: dataPoints.map((point) => {
//           const value = point.y || point; // Ensure correct value extraction for the point
//           if (isMergedGraph && i === 1) {
//             if (value <= graph_det.min_threshold) {
//               return mergedGraphColor[0]; // First merged graph color for low values
//             } else if (value >= graph_det.max_threshold) {
//               return mergedGraphColor[2]; // Third merged graph color for high values
//             }
//             return mergedGraphColor[1]; // Default (middle) merged graph color
//           }
//           // Default logic for non-merged graphs
//           if (value <= graph_det.min_threshold) {
//             return safeColors?.[0]; // First default color for low values
//           } else if (value >= graph_det.max_threshold) {
//             return safeColors?.[2]; // Third default color for high values
//           }
//           return safeColors?.[1]; // Default middle color
//         }),
//         pointBorderColor: dataPoints.map((d) => {
//           const value = d.y || d; // Ensure correct value extraction for the point
//           if (isMergedGraph && i === 1) {
//             if (value <= graph_det.min_threshold) {
//               return mergedGraphColor[0]; // First merged graph color for low values
//             } else if (value >= graph_det.max_threshold) {
//               return mergedGraphColor[2]; // Third merged graph color for high values
//             }
//             return mergedGraphColor[1]; // Default (middle) merged graph color
//           }
//           // Default logic for non-merged graphs
//           if (value <= graph_det.min_threshold) {
//             return safeColors?.[0]; // First default color for low values
//           } else if (value >= graph_det.max_threshold) {
//             return safeColors?.[2]; // Third default color for high values
//           }
//           return safeColors?.[1]; // Default middle color
//         }),
        
//         pointRadius: 5,
//         segment: {
//           borderColor: ctx => {
//             const value = ctx.p1.parsed.y;
        
//             if (isMergedGraph && i === 1) {
//               // Use merged graph colors
//               if (value <= graph_det.merged_graphs[0].min_threshold) {
//                 return mergedGraphColor[0];
//               } else if (value >= graph_det.merged_graphs[0].max_threshold) {
//                 return mergedGraphColor[2];
//               }
//               return mergedGraphColor[1];
//             } else {
//               // Use regular graph colors
//               if (value <= graph_det.min_threshold) {
//                 return safeColors?.[0];
//               } else if (value >= graph_det.max_threshold) {
//                 return safeColors?.[2];
//               }
//               return safeColors?.[1];
//             }
//           },
//         },
        
//       });
//     });

//     // Convert Set to sorted Array for consistent labels
//     const sortedLabels = Array.from(allLabels).sort();

//     setChartData({
//       labels: sortedLabels,
//       datasets,
//     });

//     setMinVal(min);
//     setMaxVal(max);
//   }
// }, [data, graph_det]);


//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       title: {
//         display: true,
//         text: 'Line Chart',
//       },
//     },
//     interaction: {
//       intersect: false,
//     },
//     scales: {
//       x: {
//         display: true,
//         title: {
//           display: true,
//           text: 'Date time',
//         },
//         ticks: {
//           autoSkip: true,
//           maxTicksLimit: 10,
//           maxRotation: 0,
//         },
//       },
//       y: {
//         display: true,
//         title: {
//           display: true,
//           text: 'Value',
//         },
//         suggestedMin: minVal - 1,
//         suggestedMax: maxVal + 2 > minVal ? maxVal + 2 : minVal + 1,
//         ticks: {
//           stepSize: 1,
//           callback: function (value) {
//             return value.toFixed(0);
//           },
//         },
//       },
//     },
//     elements: {
//       line: {
//         tension: 0.4, // Smooth lines
//       },
//     },
//   };

//   return (
//     <div style={{ position: 'relative', height: '400px', width: '100%' }}>
//       {chartData.datasets && <Line data={chartData} options={options} />}
//     </div>
//   );
// }

// export default LineChart;







import React, { useEffect, useState, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { 
  Chart as ChartJS, 
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js';

// Register Chart.js components once at module level
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

function LineChart({ data, graph_det }) {
  const [chartData, setChartData] = useState(null);
  const [minVal, setMinVal] = useState(Number.POSITIVE_INFINITY);
  const [maxVal, setMaxVal] = useState(Number.NEGATIVE_INFINITY);
  const [dataValidationErrors, setDataValidationErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  const chartRef = useRef(null);
  const hasInitializedRef = useRef(false); // Track if component has been initialized once
  
  // Data validation function
  const validateData = (inputData) => {
    const errors = [];
    
    if (!inputData || !Array.isArray(inputData)) {
      errors.push("Data must be an array");
      return { isValid: false, errors, cleanData: [] };
    }

    const cleanData = inputData.map((dataset, datasetIndex) => {
      if (!Array.isArray(dataset)) {
        errors.push(`Dataset ${datasetIndex} is not an array`);
        return [];
      }

      return dataset.filter((item, itemIndex) => {
        // Check if item has required properties
        if (!item || typeof item !== 'object') {
          errors.push(`Dataset ${datasetIndex}, item ${itemIndex}: Invalid item format`);
          return false;
        }

        if (item.datetime=== undefined || typeof item.datetime !== 'string') {
          errors.push(`Dataset ${datasetIndex}, item ${itemIndex}: Missing or invalid datetime`);
          return false;
        }

        if (item.value === undefined && (typeof item.value !== 'string' && typeof item.value !== 'number')) {
          errors.push(`Dataset ${datasetIndex}, item ${itemIndex}: Missing or invalid value`);
          return false;
        }

        // Validate datetime format "HH:mm:ss dd/MM/yyyy"
        try {
          const parsedDate = parseCustomDateTime(item.datetime);
          if (isNaN(parsedDate.getTime())) {
            errors.push(`Dataset ${datasetIndex}, item ${itemIndex}: Invalid datetime values`);
            return false;
          }
        } catch (e) {
          errors.push(`Dataset ${datasetIndex}, item ${itemIndex}: Cannot parse datetime`);
          return false;
        }

        // Validate if value can be converted to number
        const numValue = parseFloat(item.value);
        if (isNaN(numValue)) {
          errors.push(`Dataset ${datasetIndex}, item ${itemIndex}: Value cannot be converted to number`);
          return false;
        }

        return true;
      });
    });

    return {
      isValid: errors.length === 0,
      errors,
      cleanData: cleanData.filter(dataset => dataset.length > 0) // Remove empty datasets
    };
  };

  // Helper function to parse the custom datetime format "HH:mm:ss dd/MM/yyyy"
const parseCustomDateTime = (datetimeStr, topic) => {
  try {
    const [timePart, datePart] = datetimeStr.split(' ');
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    const [day, month, year] = datePart.split('/').map(Number);
    const fullYear = year < 100 ? 2000 + year : year;
    const date = new Date(fullYear, month - 1, day, hours, minutes, seconds);

    // 🇴🇲 Apply -1h30m offset only for "i_a6xle9" topic
    if (topic === "i_a6xle9") {
      date.setMinutes(date.getMinutes() - 90);
    }

    return date;
  } catch (error) {
    throw new Error(`Cannot parse datetime: ${datetimeStr}`);
  }
};


  // Helper function to format datetime to 12-hour format
  const formatTo12Hour = (dateObj) => {
    return dateObj.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  // Helper function to get just the time in 12-hour format
  const getTimeOnly = (dateObj) => {
    return dateObj.toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  // Initialize component with black background immediately
  useEffect(() => {
    if (!hasInitializedRef.current) {
      setIsInitialized(true);
      hasInitializedRef.current = true;
    }
  }, []);

  // Function to update chart data smoothly
  const updateChartData = (newData, graphDetails) => {
    try {
      // Validate data first
      const validation = validateData(newData);
      setDataValidationErrors(validation.errors);

      if (!validation.isValid || validation.cleanData.length === 0) {
        console.warn("Data validation failed:", validation.errors);
        return;
      }

      const cleanData = validation.cleanData;
      let min = Number.POSITIVE_INFINITY;
      let max = Number.NEGATIVE_INFINITY;
      const allDataPoints = [];
      const datasets = [];
      const isMergedGraph = graphDetails?.merged_graphs;
      const isGraphMerged = Array.isArray(isMergedGraph) && isMergedGraph.length > 0;

      const mergedGraphName = isGraphMerged ? graphDetails.merged_graphs[0].name : null;
      const mergedGraphColor = isGraphMerged ? graphDetails.merged_graphs[0].colors || ["#00BFFF", "#00BFFF", "#00BFFF"] : null;
      const safeColors = graphDetails?.colors?.length >= 3
          ? graphDetails.colors
          : ["#00BFFF", "#00BFFF", "#00BFFF"];

      cleanData.forEach((dataset, i) => {
        // Parse and sort dataset by datetime
        const sortedData = [...dataset]
          .map(d => ({
            ...d,
              parsedDate: parseCustomDateTime(d.datetime, graph_det?.device_id?.topic)
          }))
          .sort((a, b) => a.parsedDate - b.parsedDate);

        const dataPoints = sortedData.map(d => {
          const value = parseFloat(d.value);
          min = Math.min(min, value);
          max = Math.max(max, value);

          const timestamp = d.parsedDate.getTime();
          const fullLabel = formatTo12Hour(d.parsedDate);
          
          allDataPoints.push({
            timestamp,
            label: fullLabel,
            dateObj: d.parsedDate,
            originalDateTime: d.datetime
          });

          return { 
            x: timestamp,
            y: value,
            fullLabel: fullLabel,
            dateObj: d.parsedDate
          };
        });

        const datasetLabel = i === 0 
          ? `${graphDetails?.name || 'Dataset 1'}`
          : mergedGraphName || 'Dataset 2';

        datasets.push({
          label: datasetLabel,
          data: dataPoints,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          pointBackgroundColor: dataPoints.map((point) => {
            const value = point.y;
            if (isMergedGraph && i === 1) {
              if (value <= (graphDetails?.min_threshold || 0)) {
                return mergedGraphColor[0];
              } else if (value >= (graphDetails?.max_threshold || 0)) {
                return mergedGraphColor[2];
              }
              return mergedGraphColor[1];
            }
            if (value <= (graphDetails?.min_threshold || 0)) {
              return safeColors?.[0];
            } else if (value >= (graphDetails?.max_threshold || 0)) {
              return safeColors?.[2];
            }
            return safeColors?.[1];
          }),
          pointBorderColor: dataPoints.map((point) => {
            const value = point.y;
            if (isMergedGraph && i === 1) {
              if (value <= (graphDetails?.min_threshold || 0)) {
                return mergedGraphColor[0];
              } else if (value >= (graphDetails?.max_threshold || 0)) {
                return mergedGraphColor[2];
              }
              return mergedGraphColor[1];
            }
            if (value <= (graphDetails?.min_threshold || 0)) {
              return safeColors?.[0];
            } else if (value >= (graphDetails?.max_threshold || 0)) {
              return safeColors?.[2];
            }
            return safeColors?.[1];
          }),
          
          pointRadius: 5,
          segment: {
            borderColor: ctx => {
              const value = ctx.p1.parsed.y;
          
              if (isMergedGraph && i === 1) {
                if (value <= (graphDetails?.merged_graphs?.[0]?.min_threshold || 0)) {
                  return mergedGraphColor[0];
                } else if (value >= (graphDetails?.merged_graphs?.[0]?.max_threshold || 0)) {
                  return mergedGraphColor[2];
                }
                return mergedGraphColor[1];
              } else {
                if (value <= (graphDetails?.min_threshold || 0)) {
                  return safeColors?.[0];
                } else if (value >= (graphDetails?.max_threshold || 0)) {
                  return safeColors?.[2];
                }
                return safeColors?.[1];
              }
            },
          },
        });
      });

      // Create unified labels sorted by timestamp
      const uniqueTimestamps = [...new Set(allDataPoints.map(point => point.timestamp))].sort((a, b) => a - b);
      
      // Check if data spans multiple days
      const dates = uniqueTimestamps.map(ts => new Date(ts));
      const uniqueDates = [...new Set(dates.map(d => d.toDateString()))];
      const spanMultipleDays = uniqueDates.length > 1;

      // Create all labels to show all data points
      const unifiedLabels = uniqueTimestamps.map(timestamp => {
        const dateObj = new Date(timestamp);
        if (spanMultipleDays) {
          return formatTo12Hour(dateObj);
        } else {
          return getTimeOnly(dateObj);
        }
      });

      setChartData({
        labels: unifiedLabels,
        datasets,
      });

      setMinVal(min);
      setMaxVal(max);
      
    } catch (error) {
      console.error('Error updating chart data:', error);
    }
  };

  // Main effect for data updates - only runs when data changes
  useEffect(() => {
    if (data && isInitialized) {
      // Only show loading for the initial load
      if (!hasInitializedRef.current || !chartData) {
        setIsLoading(true);
        
        // Small delay only for initial load
        const timer = setTimeout(() => {
          updateChartData(data, graph_det);
          setIsLoading(false);
        }, 500);
        
        return () => clearTimeout(timer);
      } else {
        // For subsequent updates, update immediately without loading state
        updateChartData(data, graph_det);
      }
    }
  }, [data, graph_det, isInitialized]);

  // Cleanup chart on unmount
  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy?.();
      }
    };
  }, []);

  // Check if data spans multiple days for axis title
  const getAxisTitle = () => {
    if (!data || data.length === 0) return 'Time';
    
    try {
      const allDates = data.flat().map(d => parseCustomDateTime(d.datetime));
      const uniqueDates = [...new Set(allDates.map(d => d.toDateString()))];
      
      return uniqueDates.length > 1 ? 'Date & Time' : 'Time';
    } catch (error) {
      return 'Time';
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    // Disable animations for smoother updates
    animation: false,
    plugins: {
      title: {
        display: true,
        text: 'Line Chart',
        color: '#ffffff'
      },
      legend: {
        labels: {
          color: '#ffffff'
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        callbacks: {
          title: function(context) {
            const dataIndex = context[0].dataIndex;
            const dataset = context[0].dataset;
            const dataPoint = dataset.data[dataIndex];
            
            if (dataPoint.fullLabel) {
              return dataPoint.fullLabel;
            }
            
            const dateObj = new Date(dataPoint.x);
            return formatTo12Hour(dateObj);
          },
          label: function(context) {
            return `${context.dataset.label}: ${context.parsed.y}`;
          }
        }
      }
    },
    interaction: {
      intersect: false,
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: getAxisTitle(),
          color: '#ffffff'
        },
        ticks: {
          autoSkip: false,
          maxTicksLimit: 20,
          maxRotation: 60,
          minRotation: 45,
          font: {
            size: 10
          },
          color: '#ffffff',
        
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        }
      },
      y: {
        display: true,
        title: {
          display: true,
          text: 'Value',
          color: '#ffffff'
        },
        suggestedMin: minVal - 1,
        suggestedMax: maxVal + 2 > minVal ? maxVal + 2 : minVal + 1,
        ticks: {
          stepSize: 0.1,
          callback: function (value) {
            return value.toFixed(1);
          },
          color: '#ffffff'
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        }
      },
    },
    elements: {
      line: {
        tension: 0.8,
      },
    },
  };

  // Container style with immediate black background
  const containerStyle = {
    position: 'relative',
    height: '400px',
    width: '100%',
    backgroundColor: 'transparent',
    borderRadius: '4px',
    overflow: 'hidden'
  };

  // Don't render anything until initialized to prevent white flash
  if (!isInitialized) {
    return <div style={containerStyle}></div>;
  }

  // Show loading state only for initial load
  if (isLoading && !chartData) {
    return (
      <div style={{
        ...containerStyle,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #333333',
            borderTop: '4px solid #007bff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 10px'
          }}></div>
          <p style={{ color: '#ffffff', margin: 0 }}>Loading chart...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Show validation errors if any
  if (dataValidationErrors.length > 0) {
    return (
      <div style={{ ...containerStyle, padding: '20px', color: '#ffffff' }}>
        <div style={{ color: '#ff6b6b', marginBottom: '10px' }}>
          <h4>Data Validation Errors:</h4>
          

        </div>
      </div>
    );
  }

  // Show message if no valid chart data
  if (!chartData) {
    return (
      <div style={{
        ...containerStyle,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <p style={{ color: '#ffffff', margin: 0 }}>No valid data to display</p>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <Line 
        ref={chartRef}
        data={chartData} 
        options={options}
      />
    </div>
  );
}

export default LineChart;